import React, { FunctionComponent, useContext } from "react";
import { useForm } from "react-hook-form";
import { ensure, Form, FormActions, FormFields, FormTextField, Stack } from "sprint-common-web";

import { LanguagesDataContext } from "../../../../../common/data/lookup-data-providers/LanguagesDataProvider";
import { MuxSpecificationDashboardContext } from "../../context/MuxSpecificationDashboardContext";
import { ensureIsManzanitaMuxSpecification } from "../../MuxSpecificationDashboardItem";
import { ensureDictionaryLanguageSpecification } from "../ManzanitaMuxSpecificationLanguageMappingsSection";
import { useEditLanguagexSpecificationMappingForm } from "./useEditLanguageSpecificationMappingForm";

export interface EditLanguageSpecificationFormProps {
    languageId: string;
    onCancel(): void;
    onSubmit(): void;
}

export interface EditLanguageSpecificationFormInputs {
    soundtrackPid: string;
    subtitlePid: string;
}

export const EditLanguageSpecificationMappingForm: FunctionComponent<EditLanguageSpecificationFormProps> = (
    props: EditLanguageSpecificationFormProps
) => {
    const { languageId, onCancel, onSubmit } = props;
    const { languages } = useContext(LanguagesDataContext);
    const { muxSpecificationDashboardItem } = useContext(MuxSpecificationDashboardContext);
    ensureIsManzanitaMuxSpecification(muxSpecificationDashboardItem);
    const { languageSpecification } = muxSpecificationDashboardItem;

    ensureDictionaryLanguageSpecification(languageSpecification);

    const { editLanguageSpecificationMapping } = useEditLanguagexSpecificationMappingForm();

    const { errors, formState, control, reset, handleSubmit } = useForm<EditLanguageSpecificationFormInputs>({
        defaultValues: {
            soundtrackPid: languageSpecification.soundtrackLanguagePidDictionary[languageId],
            subtitlePid: languageSpecification.subtitleLanguagePidDictionary[languageId]
        },
        criteriaMode: "all"
    });

    const handleEditLanguageSpecificationMapping = async (inputs: EditLanguageSpecificationFormInputs) => {
        const language = languages.find((item) => item.id === languageId);
        ensure(language);

        await editLanguageSpecificationMapping(language, inputs);
        onSubmit();
        reset();
    };

    const handleCancelButtonClick = () => {
        reset();
        onCancel();
    };

    return (
        <Stack>
            <Form onSubmit={handleSubmit(handleEditLanguageSpecificationMapping)}>
                <Stack verticalAlign="space-between">
                    <FormFields>
                        <FormTextField label="SoundtrackPid" control={control} name="soundtrackPid" errors={errors} />
                        <FormTextField label="SubtitlePid" control={control} name="subtitlePid" errors={errors} />
                    </FormFields>
                    <FormActions
                        isLoading={formState.isSubmitting || formState.isValidating}
                        onCancel={handleCancelButtonClick}
                    />
                </Stack>
            </Form>
        </Stack>
    );
};
